var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'tw-flex tw-justify-between',
    {
      'tw-mix-blend-luminosity': _vm.disabled,
    },
  ],attrs:{"id":_vm.id + '___FB_spinButton_'}},[_c('span',{class:[
      'tw-inline-flex justify-content-center',
      {
        'tw-cursor-pointer': !_vm.disabled,
      },
    ],on:{"click":_vm.decrement}},[_c('MinusSquareIcon',{staticClass:"tw-fill-negative tw-stroke-1.5"})],1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"}],class:[
      'tw-text-center tw-max-w-[4rem]',
      {
        'tw-bg-white': !_vm.inheritedBackground,
      },
    ],attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.modelValue)},on:{"input":function($event){if($event.target.composing)return;_vm.modelValue=$event.target.value}}}),_c('span',{class:[
      'tw-inline-flex justify-content-center',
      {
        'tw-cursor-pointer': !_vm.disabled,
      },
    ],on:{"click":_vm.increment}},[_c('PlusSquareIcon',{staticClass:"tw-fill-active tw-stroke-1.5"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }